var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-begin m-2 m-sm-0"},[(_vm.periods && _vm.periods.length > 1)?_c('PeriodDropdown',{staticStyle:{"max-width":"100px"}}):_vm._e(),_c('CompanyDropdown',{staticClass:"ml-4",attrs:{"company_id":_vm.company_id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }